<style>
/* #NewUserLayer .v--modal-box.v--modal {
  min-height: 480px !important;
  min-width: 500px !important;
} */
#NewUserLayer * {
  font-size: 12px;
}
#NewUserLayer .list--el--bold {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.54);
}
/*#modals-container > div > div > div.v--modal-box.v--modal {
  height: 220px !important;
}*/
</style>

<template>
  <Modal
    modalName="NewUserLayer"
    :title="editing ? 'Edycja aktywnej warstwy użytkownika' : 'Tworzenie warstwy użytkownika'"
    @opened="open"
    @closed="closed"
    @saved="save"
    :buttons="['save']"
  >
    <v-container>
      <v-layout row wrap>
        <p
          class="font--primary"
          v-if="editing"
        >W celu edycji aktualnie wybranej warstwy użytkownika wprowadź informacje, a następnie naciśnij przycisk u dołu okna.</p>
        <p
          class="font--primary"
          v-else
        >W celu dodania nowej warstwy użytkownika wprowadź informacje, a następnie naciśnij przycisk u dołu okna.</p>
        <v-flex xs5>
          <v-text-field label="Nazwa warstwy" v-model="layerName" :rules="columnNameRule"></v-text-field>
        </v-flex>
        <v-spacer/>
        <v-flex xs5 v-if="!editing">
          <v-text-field
            label="SRID"
            v-model="layerSRID"
            @keypress="isNumber($event)"
            :rules="newLayerRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs5 id="modalSelect__type">
          <v-select
            :items="layersTypes"
            attach="#modalSelect__type .v-input__slot"
            label="Typ warstwy użytkownika"
            item-text="name"
            v-model="layerType"
            :rules="newLayerRules"
          ></v-select>
        </v-flex>
        <v-spacer/>
        <v-flex xs5 id="modalSelect__geomTypes" v-if="!editing">
          <v-select
            :items="geometryTypes"
            attach="#modalSelect__geomTypes .v-input__slot"
            label="Dopuszczalny typ geometrii"
            :return-object="true"
            item-text="name"
            v-model="geometryType"
            :rules="newLayerRules"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-subheader>Pola</v-subheader>
          <p>
            <v-icon
              style="font-size: 16px; margin-right: 5px;"
              @click="showAddNewField"
            >add_circle_outline</v-icon>Dodaj nowe pole
          </p>
          <v-list>
            <v-list-tile class="list--el">
              <v-list-tile-title class="list--el--bold">Nazwa</v-list-tile-title>
              <v-list-tile-title class="list--el--bold">Typ danych</v-list-tile-title>
              <v-list-tile-title style="width: 100px" class="list--el--bold">Opcje</v-list-tile-title>
            </v-list-tile>
            <template v-for="(field,index) in tabFields">
              <v-list-tile class="list--el" :key="index">
                <v-list-tile-title>{{field.name}}</v-list-tile-title>
                <v-list-tile-title>{{colMap[field.data_type]}}</v-list-tile-title>
                <v-list-tile-title style="width: 100px">
                  <span>
                    <v-icon
                      title="Edycja"
                      v-if="!editing && field.name != 'ogc_fid'"
                      style="font-size: 16px;"
                      @click="editField(index)"
                    >edit</v-icon>
                    <v-icon
                      title="Usuwanie"
                      style="font-size: 16px;"
                      v-if="field.name != 'ogc_fid'"
                      @click="removeField(index)"
                    >delete</v-icon>
                  </span>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";

mixin(_, {
  chain,
  map
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal
  },
  data: () => ({
    newLayerRules: [v => !!v || "To pole jest wymagane"],
    columnNameRule: [v => v != "ogc_fid" || "Niedozwolona nazwa kolumny"],
    layerSRID: undefined,
    layerName: undefined,
    xName: undefined,
    yName: undefined,
    tabFields: [
      {
        data_type: "integer",
        name: "ID"
      }
    ],
    columnTypes: [
      {
        name: "Tekst",
        key: "text"
      },
      {
        name: "Liczby całkowite",
        key: "integer"
      },
      {
        name: "Liczby rzeczywiste",
        key: "float"
      }
    ],
    colMap: {
      text: "Tekst",
      integer: "Liczby całkowite",
      float: "Liczby rzeczywiste"
    },
    fieldName: undefined,
    layersTypes: [
      {
        name: "Prywatna",
        key: false
      },
      {
        name: "Publiczna",
        key: true
      }
    ],
    layerType: undefined,
    geometryTypes: [
      {
        name: "Punkt",
        key: "POINT"
      },
      {
        name: "Linia",
        key: "LINESTRING"
      },
      {
        name: "Wielokąt",
        key: "POLYGON"
      }
    ],
    geometryType: undefined,
    editingIndex: undefined,
    editing: false,
    editLayer: undefined
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    userLayers() {
      return this.$store.getters.getUserLayers;
    }
  },
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    open() {
      if (this.editing) {
        for (let lay of this.userLayers) {
          if (lay.table === this.editLayer.table) {
            this.layerName = lay.name;
            this.layerSRID = lay.srid;
            this.layerType = lay.public ? "Publiczna" : "Prywatna";
            this.geometryType = this.getGeometryType(lay.geometry_type);
            this.tabFields = lay.fields;
            break;
          }
        }
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getGeometryType(geometry_type) {
      switch (geometry_type) {
        case "point":
          return this.geometryTypes[0];
        case "linestring":
          return this.geometryTypes[1];
        case "polygon":
          return this.geometryTypes[2];
        default:
          return {
            name: "Nie przestrzenna",
            key: "NOGEOMETRY"
          };
      }
    },
    removeField(index) {
      this.tabFields.splice(index, 1);
    },
    editField(index) {
      this.editingIndex = index;
      this.$root.$emit("editField", [
        this.tabFields[index].name,
        this.tabFields[index].data_type
      ]);
      this.show("addNewField");
    },
    editUserLayer(data) {
      this.editing = true;
      this.editLayer = data;
    },
    mapFieldType(field) {
      switch (field.data_type) {
        case "integer":
          field.data_type = "integer";
          break;
        case "float":
          field.data_type = "float";
          break;
        default:
          field.data_type = "text";
          break;
      }
      return field;
    },
    save() {
      if (
        !this.layerName ||
        (!this.editing && !this.layerSRID) ||
        !this.layerType ||
        !this.geometryType
      )
        return;
      const tempFields = _.map(this.tabFields, f => this.mapFieldType(f));
      const tempPublic = this.layerType === "Prywatna" ? false : true;
      if (!this.editing) {
        // Dodawanie warstwy
        const payload = {
          fields: tempFields,
          geometry_type: this.geometryType.key,
          name: this.layerName,
          public: tempPublic,
          srid: this.layerSRID
        };
        this.$store.dispatch("addEmptyUserLayer", payload).then(res => {
          if (res.status === 200) {
            payload.table = res.data.inserted;
            this.$root.$emit("addUserLayer", payload);

            this.$modal.hide("NewUserLayer");
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano warstwę użytkownika"
            );
          } else {
            this.$root.$emit("showSnackbar", "red", `${res.message}`);
          }
        });
      } else {
        // edycja
        const payload = {
          table: this.editLayer.table,
          body: {
            fields: tempFields,
            layer_name: this.layerName,
            public: tempPublic
          }
        };
        this.$store.dispatch("editUserLayer", payload).then(res => {
          if (res.status === 200) {
            this.$root.$emit("updateUserLayer", this.editLayer.table, {
              name: this.layerName,
              fields: tempFields,
              public: tempPublic
            });
            this.$modal.hide("NewUserLayer");
          } else {
            this.$root.$emit("showSnackbar", "red", `${res}`);
          }
        });
      }
    },
    showAddNewField() {
      this.show("addNewField");
    },
    fieldSaved(data) {
      if (data[2]) {
        this.removeField(this.editingIndex);
      }
      this.tabFields.push({
        data_type: data[1].key,
        name: data[0]
      });
    },
    closed() {
      if (!this.editing) {
        this.tabFields = [
          {
            data_type: "Liczba całkowita",
            name: "ID"
          }
        ];
        this.layerType = undefined;
        this.geometryType = undefined;
        this.layerName = undefined;
        this.layerSRID = undefined;
        this.editingIndex = undefined;
        this.editLayer = undefined;
        this.editing = false;
      }
    }
  },
  mounted() {
    this.$root.$on("fieldSaved", this.fieldSaved);
    this.$root.$on("editUserLayer", this.editUserLayer);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/NewUserLayer.vue